import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import { DrillDownComponent } from "../../../../common/drilldown/drilldown.component";
import { TreeViewEntity } from "../../../../models/tree-view-entity.model";
import { BusinessUnitService } from "../../../../services/business-unit.service";
import { FeedbackService } from "../../../../services/feedback.service";
import { saveAs } from "file-saver";
import { Subject, Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { UserService } from "../../../../services/user.service";
import { UserPersonInfo } from "../../../../models/identity";
import { ConfigService } from "../../../../services/config.service";
import { FeedbackChatReportModel } from "./feedback-chat-report.mode";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";

@Component({
  selector: "app-feedback-chat-report",
  templateUrl: "./feedback-chat-report.component.html",
  styleUrls: ["./feedback-chat-report.component.scss"],
})
export class FeedBackChatReportComponent implements OnInit, OnDestroy {
  businessUnits: Array<TreeViewEntity>;
  isSpinnerEnable: boolean;
  @ViewChild("drilldownSelect") drilldownSelect: DrillDownComponent;
  downloadSubscription: Subscription;
  routeSubscription: Subscription;
  defaultbusinessUnitId: number;
  searchedEmployees: Array<UserPersonInfo>;
  model = new FeedbackChatReportModel();
  employeeSearcheSubject = new Subject<string>();
  employeeSearcheSubs: Subscription;

  constructor(
    private _businessUnitService: BusinessUnitService,
    private _feedbackService: FeedbackService,
    private _actRoute: ActivatedRoute,
    private _userService: UserService,
    private _configService: ConfigService
  ) {}

  ngOnInit() {
    this._businessUnitService.getTreeView().subscribe((businessUnits) => {
      this.businessUnits = businessUnits;
    });
    this.routeSubscription = this._actRoute.parent.parent.paramMap.subscribe((x) => {
      this.defaultbusinessUnitId = +x.get("businessUnitId");
    });

    this.employeeSearcheSubs = this.employeeSearcheSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((event) => this._userService.getBySearchPattern(event))
      )
      .subscribe((employees) => {
        this.searchedEmployees = employees;
      });
  }

  onBusinessUnitSelected(businessUnit: TreeViewEntity) {
    this.model.BusinessUnit = businessUnit && businessUnit.id ? businessUnit : null;
  }

  searchEmployeeByName(search: string) {
    if (!this.checkIfPatternReady(search)) {
      return;
    }
    this.employeeSearcheSubject.next(search);
  }

  download() {
    if (this.model.invalid) {
      return;
    }
    this.isSpinnerEnable = true;
    this.downloadSubscription = this._feedbackService
      .getFeedbackChatReport(
        this.model.StartDate,
        this.model.EndDate,
        this.model.BusinessUnit,
        this.model.Employee
      )
      .subscribe(
        (data) => {
          saveAs(
            data,`FBChat_${this.localeTime(new Date())}.xlsx`
          );
          this.isSpinnerEnable = false;
        },
        (x) => {
          this.isSpinnerEnable = false;
        }
      );
  }

  clearAll() {
    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    this.model.StartDate = startDate;
    this.model.EndDate = new Date();
    this.model.Employee = null;
    this.model.BusinessUnit = null;
    if (this.drilldownSelect) {
      this.drilldownSelect.onClearClicked();
    }
  }
  
  ngOnDestroy() {
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
    }
    if(this.routeSubscription){
      this.routeSubscription.unsubscribe();
    }
    if (this.employeeSearcheSubs) {
      this.employeeSearcheSubs.unsubscribe();
    }
    if (this.employeeSearcheSubject) {
      this.employeeSearcheSubject.complete();
    }
  }

  private localeTime(source: Date) {
    const offset = moment().utcOffset();
    return moment
      .utc(source)
      .utcOffset(offset)
      .locale("en")
      .format("H:mm | D MMMM");
  }

  private checkIfPatternReady(pattern: string): boolean {
    return (
      pattern.length >= this._configService.configData.minimumSearchStringLength
    );
  }
}
